import { useCollection, useIsOwnSpace } from "@/api/hooks";
import ImportDialog, { ExportButton } from "./ImportDialog";

/**
 * Import and export, scoped to the collection currently open — the imported
 * tree is filed under it, and the export covers only its subtree.
 *
 * The space-wide counterpart is SpaceTransferSheet, reached from the user menu.
 * Owner-only, matching the endpoints.
 */
export default function CollectionTransfer() {
  const collection = useCollection();
  const isOwnSpace = useIsOwnSpace();

  if (!isOwnSpace || !collection) return null;

  return (
    <div className="flex flex-col gap-2 rounded-[10px] border border-border bg-secondary px-4 py-3">
      <p className="text-[11px] font-bold uppercase tracking-[.06em] text-muted-foreground">
        Import and export
      </p>
      <p className="text-[12px] text-muted-foreground">
        Add a tree of collections and records from a JSON file, filed under this
        collection.
      </p>
      <ImportDialog
        collectionID={collection.id}
        collectionTitle={collection.title}
      />
      <ExportButton
        collectionID={collection.id}
        collectionTitle={collection.title}
      />
    </div>
  );
}
